import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";

export const deleteNotification = async (
  agree: boolean | null,
  params: stdObject,
) => {
  const {
    t,
    notification,
    index,
    windowValues,
    setWindowValues,
    setModalData2,
    setMsg2,
    closeMsg,
    logoutAction,
  } = params;
  if (agree) {
    setMsg2("loading");
    const payloadDeleteNotification = { id: notification.IDTA0 };
    const responseDeleteNotification: stdObject = await sendData({
      endPoint: "deleteNotification",
      payload: payloadDeleteNotification,
      logoutAction,
    });

    if (responseDeleteNotification.success && responseDeleteNotification.status) {
      const notifications = windowValues.notifications.filter(
        (_: stdObject, i: number) => i !== index,
      );
      setWindowValues({ ...windowValues, notifications });
      closeMsg(2);
    } else {
      setMsg2("error");
    }
  } else {
    setMsg2("custom2");
    setModalData2({
      code: "warning",
      title: t("p.askDeleteNotification"),
      buttons: [
        {
          label: t("p.accept"),
          onClick: () => deleteNotification(true, params),
          color: colors.red,
        },
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    });
  }
};
